import { useNavigate } from 'react-router-dom';
import { NutritionEssentialCard } from '@screens/HomePage/ResultReady/NutritionEssentialCard';
import { ChevronRightIcon } from '@/components/icons/ChevronRightIcon';
import { BOOSTERS_AND_BLOCKERS_PATH } from '@/constants/paths';
import { useGetNutritionSummary } from '@viome/viome-base/src/usecase/Home/HomeQuery';
import { Skeleton } from '@design-system/Skeleton';
import {
  Carousel,
  CarouselNext,
  CarouselItem,
  CarouselContent,
  CarouselPrevious,
} from '@design-system/Carousel';
import { EventTracker } from '@/utils';

export const NutritionEssentials = () => {
  const {
    data: nutritionSummaryData,
    isLoading,
    isError,
  } = useGetNutritionSummary();

  const navigate = useNavigate();
  const handleSeeAll = () => {
    EventTracker.trackEvent('home', 'home_nutritionSummary_seeAll');
    navigate(BOOSTERS_AND_BLOCKERS_PATH);
  };

  if (isLoading) {
    return (
      <div className="space-y-6 w-full">
        <div>
          <h2 className="typography-d2 text-primary">Improve Your Health</h2>
          <p className="typography-body text-primary/70 max-w-[35rem]">
            We turned your health insights into clear health goals. Your nutrition
            recommendations work together synergistically to improve these areas of your
            health.
          </p>
        </div>

        <div className="mt-8">
          <Carousel
            className="relative"
            opts={{
              align: 'start',
              dragFree: true
            }}
          >
            <CarouselContent className="-ml-6 gap-2">
              {[1, 2, 3, 4].map((index) => (
                <CarouselItem
                  key={`skeleton-${index}`}
                  className="pl-6 basis-80"
                >
                  <Skeleton className="w-80 h-28 rounded-2xl" />
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="hidden" />
            <CarouselNext className="hidden" />
          </Carousel>
        </div>

        <Skeleton className="w-full h-12 rounded-2xl" />
      </div>
    );
  }

  if (isError || !nutritionSummaryData?.length) {
    return;
  }

  return (
    <div className="space-y-6 w-full">
      <div>
        <h2 className="typography-d2 text-primary pb-4">
          Improve Your Health
        </h2>
        <p className="typography-body text-primary/70 max-w-[35rem]">
          We turned your health insights into clear health goals. Your nutrition
          recommendations work together synergistically to improve these areas of your
          health.
        </p>
      </div>

      <div className="mt-8">
        <Carousel
          className="relative"
          opts={{
            align: 'start',
            dragFree: true,
          }}
        >
          <CarouselContent className="-ml-6 gap-2">
            {nutritionSummaryData?.map((item, index) => (
              <CarouselItem
                key={`nutrition-${index}`}
                className="pl-6 basis-80"
              >
                <NutritionEssentialCard
                  boosterBlockerId={Number(item.id)}
                  title={item.title}
                  images={item.image_urls}
                  foodCount={item.count}
                  icon_url={item.icon_url}
                />
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious className="hidden" />
          <CarouselNext className="hidden" />
        </Carousel>
      </div>

      <button
        onClick={handleSeeAll}
        className="w-full h-12 flex items-center justify-between px-6 bg-background-blur-bold backdrop-blur-[50px] rounded-2xl text-primary"
      >
        <span className="typography-btn-large">See all</span>
        <ChevronRightIcon className="w-5 h-5" />
      </button>
    </div>
  );
};
